import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CustomsHandlingItem from '@/components/CustomsHandlingItem.vue.html';
import { CustomsHandlingApi, SearchResultViewModel } from '@/openapi';

export default /*#__PURE__*/_defineComponent({
  __name: 'Shipments',
  setup(__props) {

const api = new CustomsHandlingApi(undefined, '');

const result = ref<SearchResultViewModel[]>([]);
const headers = ref([
    { text: 'HAWB', value: 'hawb' },
    { text: 'MAWB', value: 'mawb' },
    { text: 'Sender', value: 'sender' },
    { text: 'MRN', value: 'mrn' },
    { text: 'Last milestone', value: 'lastMilestone' },
]);

const reference = ref('');
const customer = ref('');
const mrn = ref('');
const mawb = ref('');
const loading = ref(false);
const footerProps = ref({
    'items-per-page-options': [50, 100, 250],
});

const copyToClipboard = (text: string | undefined) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
};

const search = () => {
    result.value = [];
    if (
        loading.value ||
        (!reference.value && !customer.value && !mrn.value && !mawb.value)
    ) {
        return;
    }

    loading.value = true;
    api.search(reference.value, customer.value, mrn.value, mawb.value)
        .then((response) => {
            if (response.data !== undefined && response.data.length > 0) {
                result.value = response.data;
            }
            loading.value = false;
        })
        .catch(() => {
            loading.value = false;
        });
};

return { __sfc: true,api, result, headers, reference, customer, mrn, mawb, loading, footerProps, copyToClipboard, search, CustomsHandlingItem }
}

})